import { ethers } from 'ethers'
import { getTokenAbi,  } from '../app/tokenAbi'
import { provider } from '../app/contracts';
import axios from 'axios'


export const getPrices = async () => {
    const pricesFromCache = await axios.get('https://cache.rune.game/stats.json?a=5464224')
    const pricesObj = await pricesFromCache.data.prices
    const tokenAbi = getTokenAbi()
    const btcbnbContractAddress = '0x7561EEe90e24F3b348E1087A005F78B4c8453524'
    const btcbnbContract = new ethers.Contract(btcbnbContractAddress, tokenAbi, provider)
    const reserves = await btcbnbContract.getReserves()
    const btcReservesBn = reserves[0]
    const bnbReservesBn = reserves[1]
    const btcReserves:any = ethers.utils.formatEther(btcReservesBn)
    const bnbReserves:any = ethers.utils.formatEther(bnbReservesBn)
    const valueOfBnbReserve = await bnbReserves * await pricesObj['bnb']
    const btcPrice = valueOfBnbReserve/btcReserves
    pricesObj['btcb'] = btcPrice
    return pricesObj
}